import script from "./NotificationBell.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationBell.vue?vue&type=script&setup=true&lang=js"

import "./NotificationBell.vue?vue&type=style&index=0&id=4ad91cf9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ad91cf9"]])

export default __exports__